export default {
    state: {
        loading: true,
        isShowSelect: false,
        isShowRecommendLayer: false
    },
    mutations: {
        loadingHide (state, isShow) {
            state.loading = isShow
        },
        selectLayer (state, isShow) {
            state.isShowSelect = isShow
        },
        showRecommendLayer (state, isShow) {
            state.isShowRecommendLayer = isShow
        }
    },
    actions: {},
    getters: {}
}
